// Minimal client-side auth state. Backed by an httpOnly cookie on the server;
// here we just store a shallow profile for UI and a refresh token helper.

export type User = {
  id: string
  email: string
  fullName: string
  role: 'referrer' | 'admin'
  referralCode: string
  status: 'active' | 'suspended'
  createdAt: string
}

const KEY = 'qordo.user'

export function saveUser(user: User) {
  localStorage.setItem(KEY, JSON.stringify(user))
}

export function loadUser(): User | null {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? (JSON.parse(raw) as User) : null
  } catch {
    return null
  }
}

export function clearUser() {
  localStorage.removeItem(KEY)
}

export function isAdmin(u: User | null): boolean {
  return !!u && u.role === 'admin'
}
